(function ($) {
    var intervalId = {};
    var previouslyReportedPct = {};
    var videoDurations = {};
    var videoProgress = {};

    function waitForBrightcove(callback) {
        if (typeof videojs !== "undefined") {
            callback();
        } else {
            setTimeout(function () {
                waitForBrightcove(callback);
            }, 500);
        }
    }

    $(document).ready(function () {
        waitForBrightcove(initVideoEvents);
    });

    function initVideoEvents() {
        // Find all videos in carousels and standalone on the page
        $(".video-js").each(function () {
            var videoElem = this;
            if (!$(videoElem).data("initialized")) {
                var bcPlayer = videojs(videoElem);
                var videoId = $(videoElem).attr("data-video-id") || "video-" + Math.random();

                $(videoElem).data("initialized", true);
                videoProgress[videoId] = 0; // Initialize tracking

                bcPlayer.ready(function () {
                    videoDurations[videoId] = bcPlayer.duration();
                    //  console.log("Brightcove Video Duration Found:", videoDurations[videoId]);
                    bindPlayerEvents(bcPlayer, videoId);
                });
            }
        });

        // Detect video initialization inside carousels when slides change
        $(".c03-carousel").on("afterChange", function (event, slick, currentSlide) {
            var visibleSlides = $(slick.$slides).filter(".slick-active");

            visibleSlides.each(function () {
                var videoElem = $(this).find(".video-js")[0];
                if (videoElem && !$(videoElem).data("initialized")) {
                    var bcPlayer = videojs(videoElem);
                    var videoId = $(videoElem).attr("data-video-id") || "video-" + Math.random();

                    $(videoElem).data("initialized", true);
                    videoProgress[videoId] = 0;

                    bcPlayer.ready(function () {
                        videoDurations[videoId] = bcPlayer.duration();
                        bindPlayerEvents(bcPlayer, videoId);
                    });
                }
            });
        });
    }

    function bindPlayerEvents(player, videoId) {
        player.ready(function () {
            // console.log("Player " + videoId + " is ready, binding events...");

            player.on("play", function () {
                //  console.log("Video " + videoId + " playing, pausing other videos...");
                trackAnalytics(player, videoId);
                // Pause carousel if the video is inside one
                var carouselElem = $(player.el()).closest(".c03-carousel");
                if (carouselElem.length) {
                    carouselElem.slick("slickPause");
                }
            });

            player.on("pause", function () {
                //  console.log("Video " + videoId + " paused, resuming carousel if applicable...");
                var carouselElem = $(player.el()).closest(".c03-carousel");
                if (carouselElem.length) {
                    carouselElem.slick("slickPlay");
                }
            });

            player.on("ended", function () {
                //  console.log("Video " + videoId + " ended, resuming carousel if applicable...");
                var carouselElem = $(player.el()).closest(".c03-carousel");
                if (carouselElem.length) {
                    carouselElem.slick("slickPlay");
                }
            });
        });
    }

    function trackAnalytics(player, videoId) {
        var duration = player.duration();
        if (!duration || isNaN(duration)) return;

        var pct = Math.round((player.currentTime() / duration) * 100);
        if (pct === 0) {
            // console.log("Tracking video start click for Video " + videoId);
            $(player.el()).trigger("playvideo", [{
                "eventType": "video start click",
                "eventAction": "video start click",
                "elementText": player.mediainfo ? player.mediainfo.name : "Unknown Video"
            }]);
        }

        var timeoutVal = Math.round((duration / 100) * 1000);

        // Ensure separate tracking per video
        if (intervalId[videoId]) {
            clearInterval(intervalId[videoId]);
        }

        intervalId[videoId] = setInterval(function () {
            trackProgress(player, videoId, duration);
        }, timeoutVal);
    }

    function trackProgress(player, videoId, duration) {
        var pct = Math.round((player.currentTime() / duration) * 100);

        if ([25, 50, 75, 90, 99].indexOf(pct) !== -1 && previouslyReportedPct[videoId] !== pct) {
            var text = pct === 99 ? "100 pct complete" : pct + " pct complete";
            //console.log("Tracking Progress: Video " + videoId + " - " + text);

            $(player.el()).trigger("playvideo", [{
                "eventType": text,
                "eventAction": text,
                "elementText": player.mediainfo.name
            }]);

            previouslyReportedPct[videoId] = pct;
        }

        if ([1, 50, 75, 95].indexOf(pct) !== -1) {
            // console.log("Triggering Goal Event: Video " + videoId + " - " + pct);
            $(player.el()).trigger("goaltrigger", [{ "goal": pct === 1 ? "play" : pct }]);
        }
    }

$('.vjs-playlist-player-container').each(function () {
    var mutationEle = this;
    var config = { childList: true, subtree: true };

    var callback = function (mutationList, observer) {
        mutationList.forEach(function (mutation) {
            if (mutation.type === "childList") {
                $('.vjs-poster').removeAttr('aria-disabled');
            }
        });
    };
    var observer = new MutationObserver(callback);
    observer.observe(mutationEle, config);
});
// brought from custom-component.js
(function ($) {
    $(window).on('load', function () {
        if ($('.vjs-playlist') && $('.vjs-playlist').length) {
            if ($('ol.vjs-playlist').children().length === 0) {
                $(".vjs-playlist-player-container ol.vjs-playlist").attr("role", "presentation");
            }
        }
    });
}(window.jQuery));

function consentBrightcoveHandler() {
    var element = $('.brightcove_container')[0];
    var scriptSrc = $(element).attr('data-brightcovescriptsrc');
    var id = "brightcovescript";
    var script = document.createElement('script');

    script.setAttribute('src', scriptSrc);
    script.setAttribute('id', id);
    document.body.appendChild(script);

    script.onload = function () {
        $('.brightcove_container').each(function () {
            if ($(this).attr('data-brightcovePlayerScript') != "") {
                var playerScriptValue = $(this).attr('data-brightcovePlayerScript');
                $('body').append('<script id="brightcovePlayerScriptValue" type="text/javascript" >' + playerScriptValue + ' </script>');
            }
        });
        brightcoveListener.loadPlayerScriptsConsent();
    };

    $('.user_consent_brightcovecontent').css('display', 'none');
    $('.brightcove_container').removeClass('d-none');
}

$('.user_consent_brightcovebutton').click(function () {
    consentBrightcoveHandler();
});

$('.user_consent_brightcovebutton').keydown(function (event) {
    var keycode = (event.keyCode ? event.keyCode : event.which);
    if (keycode == '13') {
        consentBrightcoveHandler();
    }
});

$(window).on('load', function () {
    if ($('.vjs-playlist') && $('.vjs-playlist').length) {
        if ($('ol.vjs-playlist').children().length === 0) {
            $(".vjs-playlist-player-container ol.vjs-playlist").attr("role", "presentation");
        }
    }
});
}(window.jQuery));

//brought from customcomponent.js
(function ($) {
function consentBrightcoveHandler() {
    var element = $('.brightcove_container')[0];
    var scriptSrc = $(element).attr('data-brightcovescriptsrc');
    var id = "brightcovescript";
    var script = document.createElement('script');

    script.setAttribute('src', scriptSrc);
    script.setAttribute('id', id);
    document.body.appendChild(script);

    script.onload = function () {
        $('.brightcove_container').each(function () {
            if ($(this).attr('data-brightcovePlayerScript') != "") {
                var playerScriptValue = $(this).attr('data-brightcovePlayerScript');
                $('body').append('<script id="brightcovePlayerScriptValue" type="text/javascript" >' + playerScriptValue + ' </script>');
            }
        });
        brightcoveListener.loadPlayerScriptsConsent();
    };

    $('.user_consent_brightcovecontent').css('display', 'none');
    $('.brightcove_container').removeClass('d-none');
}

$('.user_consent_brightcovebutton').click(function () {
    consentBrightcoveHandler();
});

$('.user_consent_brightcovebutton').keydown(function (event) {
    var keycode = (event.keyCode ? event.keyCode : event.which);
    if (keycode == '13') {
        consentBrightcoveHandler();
    }
});
}(window.jQuery));

//Analytics
analytics.eventConfig.push(
{
    "target": ".mf-player-container",
    "codeId": "sp03",
    "events": [
        {
            "eventTarget": ".video-js",
            "eventType": "playvideo",
            "tags": {
                "event": "video",
                "componentName": "video brightcove",
                "componentId": "sp03",
                "eventType": "",
                "elementType": "brightcove video",
                "elementText": "",
                //code merge from chemical
                'event1': "",
                'document_title': '',
                'eventAction': "",
                'environment': "",
                'eventCategory': "",
                'eventLabel': "",
                'page_bu': "",
                'page_language': "",
                'page_type': "",
                'pardot_cookie_id': "",
                'sitecore_contact_id': "",
                'video_id': "",
                'contentTitle': "",
                'componentType': "",
                'deviceType': ""
            }
        }
    ]
},
)
